export default "__VITE_ASSET__Ce7cIOCi__"